import React, { useRef } from "react";

import { HubHookFormDragTable, InputLabel } from "../../components";

import DipsWarningBanner from "./DipsWarningBanner";
import DipsTableRow from "./DipsTableRow";

import { handleTabDown, isSealDip, keys } from "./helper";
import { StyledStack } from "./styles";

export const DipsTable = ({
  basePath,
  locationId,
  fields = [],
  remove = () => {},
  move = () => {},
  getFieldProps = () => ({}),
  handleStationChange = () => {},
}) => {
  const rootRef = useRef(null);

  const props = {
    id: "DiopTable",
    rootRef,
    fields,
    stackProps: {
      onKeyDown: handleTabDown(rootRef),
    },
    baseProps: {
      basePath,
      locationId,
      remove,
      getFieldProps,
      handleStationChange,
    },
    validate: (start, end) => {
      const movingDip = fields[start];
      const lastDip = fields[fields.length - 1];
      const isMovingSeal = isSealDip(movingDip);
      const isLastDipSeal = isSealDip(lastDip);

      // prevent seal dips from being moved to any position except last
      if (isMovingSeal && end !== fields.length - 1) return false;
      // prevent non-seal dips from being moved to the last position if there's a seal dip there
      if (!isMovingSeal && isLastDipSeal && end === fields.length - 1)
        return false;
      return true;
    },
    move,
    getIsDisabled: (field, idx) => {
      const isLastPosition = idx === fields.length - 1;
      const isDragDisabled = isSealDip(field) && !isLastPosition;
      return isDragDisabled;
    },
    RenderRow: DipsTableRow,
    Header: () => (
      <StyledStack
        sx={{
          backgroundColor: "hubColors.greyLighter",
          padding: "8px 2px",
        }}
      >
        {keys?.map((cell) => (
          <InputLabel
            key={cell.id}
            label={cell.label}
            required={cell.required}
            marginBottom="0px"
            sx={{ textAlign: cell.center ? "center" : "start" }}
          />
        ))}
      </StyledStack>
    ),
  };
  return (
    <HubHookFormDragTable {...props}>
      <DipsWarningBanner basePath={basePath} locationId={locationId} />
    </HubHookFormDragTable>
  );
};

export default DipsTable;
